import type { InferGetStaticPropsType } from 'next';
import Head from 'next/head';
import type { ReactElement } from 'react';

import BlogsList from '@/components/Blog/BlogsList';
import Layout from '@/components/Landing/Layout';
import { getStaticBlogsListProps } from '@/utils/getStaticBlog';
import { createBreadcrumbSchema } from '@/utils/schema-org';
import { createMetaTags } from '@/utils/seo';

const CareerGuides = ({
  initialPages,
}: InferGetStaticPropsType<typeof getStaticProps>) => {
  return (
    <>
      <Head>
        {createMetaTags({
          title:
            'How to Write an ATS-Friendly Resume: Step-by-Step Guide - MindPal',
          description:
            'Expert guides on ATS resume writing, keyword optimization, and interview prep. Land more interviews with MindPal.',
        })}
        <link
          rel="canonical"
          href="https://mindpal.co/career-guides"
          key="canonical"
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'CollectionPage',
              name: 'Career Guides — MindPal',
              description:
                'Tips and tricks for job seekers: ATS optimization, resume writing, interview preparation, and career advice.',
              url: 'https://mindpal.co/career-guides',
              publisher: {
                '@type': 'Organization',
                name: 'MindPal',
                url: 'https://mindpal.co',
              },
            }),
          }}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(createBreadcrumbSchema('/career-guides')),
          }}
        />
      </Head>
      <BlogsList
        initialPages={initialPages}
        blogType="CANDIDATE"
        title="Career Guides"
        description="Tips and tricks for Candidates"
      />
    </>
  );
};

export default CareerGuides;

CareerGuides.getLayout = (page: ReactElement) => (
  <Layout theme="light">{page}</Layout>
);

export const getStaticProps = async () => {
  const { initialPages } = await getStaticBlogsListProps({
    blogType: 'CANDIDATE',
  });

  return { props: { initialPages }, revalidate: 30 };
};
